"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlatRegionDict = exports.exactSearchRegion = exports.getRegionsByName = void 0;
var class_1 = require("../assets/class");
/**
 * 精确搜寻行政区
 * @param regions 行政区地址
 * @param key 待搜索的Key值
 * @param value 待比较的Value值
 */
var exactSearchRegion = function (regions, key, value) {
    if (regions === void 0) { regions = new Array(); }
    if (key === void 0) { key = ''; }
    if (value === void 0) { value = ''; }
    return regions.find(function (item) { return item[key] === value; }) || null;
};
exports.exactSearchRegion = exactSearchRegion;
/**
 * 通过行政区名称查询行政区集合
 * @param regions 行政区地址
 * @param level 待搜索的行政区级别 (可选：province, city, county)
 * @param value 待比较的Value值
 */
var getRegionsByName = function (regions, level, value) {
    if (regions === void 0) { regions = new Array(); }
    if (level === void 0) { level = ''; }
    if (value === void 0) { value = ''; }
    return regions.filter(function (item) { return item[level] === value; });
};
exports.getRegionsByName = getRegionsByName;
var RegionWeight = /** @class */ (function () {
    function RegionWeight() {
    }
    // 获取权重值
    RegionWeight.getStrWeight = function (regionStr) {
        var weightArr = Object.keys(RegionWeight.weightDic).sort(function (a, b) { return (Number(b) - Number(a)); });
        for (var _i = 0, weightArr_1 = weightArr; _i < weightArr_1.length; _i++) {
            var weight = weightArr_1[_i];
            var inGroup = RegionWeight.weightDic[weight].some(function (value) { return regionStr.indexOf(value) > -1; });
            if (inGroup)
                return Number(weight);
        }
        return 0;
    };
    // 字典权重
    RegionWeight.weightDic = {
        40: ['北京', '上海', '深圳', '广州'],
        30: ['杭州', '东莞', '天津', '成都', '重庆', '南京', '长沙', '青岛', '佛山', '苏州', '西安', '武汉', '宁波', '郑州'],
        20: ['广东', '福建', '湖南', '江苏', '浙江'],
        10: ['香港', '澳门', '台湾'],
    };
    return RegionWeight;
}());
// 所有的行政区集
var allRegionDic = new Map();
/**
 * 获取扁平化的行政区数据颗粒列表
 * @param regionKey 行政区 key
 */
var getFlatRegionDict = function (regionKey, regions) {
    var cacheRegionData = allRegionDic.get(regionKey);
    if (cacheRegionData)
        return Promise.resolve(cacheRegionData);
    var platProvArr = new Array();
    var platCityArr = new Array();
    var platCountyArr = new Array();
    var _a = [new class_1.UserAddressImpl(), new class_1.UserAddressImpl()], tempProvince = _a[0], tempCity = _a[1];
    var regionsArr = Object.create(regions);
    regionsArr.forEach(function (province) {
        tempProvince = new class_1.UserAddressImpl(province.locationCode, province.areaCode, province.fullName);
        platProvArr.push(tempProvince);
        province.city && province.city.forEach(function (city) {
            tempCity = __assign(__assign({}, tempProvince), { locationCode: city.locationCode, cityCode: city.areaCode, city: city.fullName });
            platCityArr.push(tempCity);
            city.county ? city.county.forEach(function (county) {
                platCountyArr.push(__assign(__assign(__assign({}, tempCity), { county: county.fullName, countyCode: county.areaCode, locationCode: county.locationCode }), {
                    weight: RegionWeight.getStrWeight("" + province.fullName + city.fullName + county.fullName)
                }));
            }) : platCountyArr.push(__assign(__assign({}, tempCity), {
                weight: RegionWeight.getStrWeight("" + province.fullName + city.fullName)
            }));
        });
    });
    var assignRegion = new class_1.ThirdLevelRegionImpl(platProvArr, platCityArr, platCountyArr.sort(function (a, b) { return (b['weight'] - a['weight']); }));
    allRegionDic.set(regionKey, assignRegion);
    return assignRegion;
};
exports.getFlatRegionDict = getFlatRegionDict;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-region/dist/common/util.js
// module id = PFC9
// module chunks = 1